import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'localeDate',
  standalone: true
})
export class LocaleDate implements PipeTransform {
  constructor() { }
  transform(value: string): string {
    if (Utilities.isEmptyString(value)) {
      return "";
    }

    const date = new Date(value);
    //Here we hardcode input language to be 'en-GB' because we want all date string have the same dd/mm/yyyy format instead of customized for different languages.
    return Utilities.isValidDate(date) ? date.toLocaleDateString('en-GB') : "";
  }
}
